import creditsafeCompanySearchInput from './creditsafeCompanySearchInput';

export default class CreditsafeCompanySearch {
	constructor(creditsafeCompanySearchForm) {
		this.address1Container = document.getElementById('address1Container');
		this.address2Container = document.getElementById('address2Container');
		this.creditsafeCompanySearchForm = creditsafeCompanySearchForm;
		this.billingForm = document.getElementById('billingForm');
		this.countrySelector = document.getElementById('countrySelection');
		this.searchBarInput = document.getElementById('searchBarInput');
		this.buttonBackToSearch = document.getElementById('buttonBackToSearch');
		this.enterDataManuallyButton = document.getElementById(
			'enterDataManuallyButton',
		);
		this.enterDataManuallyOnListButton = document.getElementById(
			'enterDataManuallyOnListButton',
		);
		this.foundCompanyContainer = document.getElementById(
			'foundCompanyContainer',
		);
		this.foundAddressCreditsafe = document.getElementById(
			'foundAddressCreditsafe',
		);
		this.companyNameContainer = document.getElementById('companyNameContainer');
		this.postalCodeAndTownContainer = document.getElementById(
			'postalCodeAndTownContainer',
		);
		this.addressCardContainer = document.getElementById('addressCardContainer');
		this.companyNameValue = document.getElementById('companyName');
		this.chamberOfCommerceIdValue = document.getElementById(
			'chamberOfCommerceId',
		);
		this.creditSafeConnectIdValue = document.getElementById(
			'creditSafeConnectId',
		);
		this.creditCheckedCompanyIdValue = document.getElementById(
			'creditCheckedCompanyId',
		);
		this.sicIdValue = document.getElementById('sicId');
		this.validAddressValue = document.getElementById('validAddressId');
		this.validCompanyValue = document.getElementById('validCompanyId');
		this.companyTaxNumberValue = document.getElementById('companyTaxNumber');
		this.addressValidationContainer = document.getElementById(
			'addressValidationContainerBlock',
		);
		this.chamberOfCommerceIdContainer = document.getElementById(
			'chamberOfCommerceIdContainer',
		);
		this.foundCompanyNameCreditsafe = document.getElementById(
			'foundCompanyNameCreditsafe',
		);
		this.address1Value = document.getElementById('address1');
		this.postalCodeValue = document.getElementById('postalCode');
		this.townValue = document.getElementById('town');
		this.foundedCompaniesContainerView = document.getElementById(
			'foundedCompaniesContainerView',
		);

		this.countryIsoCode = document.getElementById('countryIsoCode')?.value;

		this.init();
	}

	init() {
		this.setVisibility();

		this.enterDataManuallyButton?.addEventListener(
			'click',
			this.onManualButtonHandler.bind(this),
		);

		this.enterDataManuallyOnListButton?.addEventListener(
			'click',
			this.onManualButtonHandler.bind(this),
		);

		this.buttonBackToSearch?.addEventListener(
			'click',
			this.creditsafeCompanySearchFormVisibility.bind(this),
		);

		if (this.buttonBackToSearch) {
			this.toggleInputLabel();
		}
		creditsafeCompanySearchInput();
		this.creditsafeCompanySearchForm.addEventListener(
			'show-billing-address-form',
			this.showBillingAddressForm.bind(this),
		);
	}

	onManualButtonHandler(event) {
		event?.preventDefault();
		this.populateCompanyData(true);
	}

	showBillingAddressForm({ detail }) {
		this.populateCompanyData(false, detail);
	}

	setVisibility() {
		this.creditsafeCompanySearchForm.toggleAttribute(
			'hidden',
			!!this.countryIsoCode,
		);
		this.countrySelector.toggleAttribute('hidden', !this.countryIsoCode);
		this.billingForm.toggleAttribute('hidden', !this.countryIsoCode);
	}

	setBillingFormVisibility() {
		this.countrySelector.toggleAttribute('hidden', false);
		this.creditsafeCompanySearchForm.toggleAttribute('hidden', true);
		this.billingForm.toggleAttribute('hidden', false);
	}

	populateCompanyData(isManual, companyDetail) {
		const countryCode = window?.dataLayer?.[0]?.navigation?.countryISO;
		this.setBillingFormVisibility();
		this.setBillingFormElementsVisibility(isManual);

		if (!isManual) {
			this.companyNameValue.value = companyDetail.companyName;
			if (this.chamberOfCommerceIdValue) {
				this.chamberOfCommerceIdValue.name = 'chamberOfCommerceId';
				this.chamberOfCommerceIdValue.value = (
					companyDetail.chamberOfCommerceId ?? ''
				).trim();
			}
			document.getElementById(
				'foundChamberOfCommerceIdCreditsafe',
			).textContent = (companyDetail.chamberOfCommerceId ?? '').trim();
			if (this.companyTaxNumberValue) {
				this.companyTaxNumberValue.name = 'companyTaxNumber';
				this.companyTaxNumberValue.value = this.getValueOrEmpty(
					companyDetail.companyTaxNumber,
				);
			}
			if (this.creditSafeConnectIdValue) {
				this.creditSafeConnectIdValue.name = 'creditSafeConnectId';
				this.creditSafeConnectIdValue.value = companyDetail.creditSafeConnectId;
			}
			if (this.creditCheckedCompanyIdValue) {
				this.creditCheckedCompanyIdValue.name = 'creditCheckedCompanyId';
				this.creditCheckedCompanyIdValue.value =
					companyDetail.creditCheckedCompanyId;
			}
			if (this.sicIdValue) {
				this.sicIdValue.name = 'sic';
				this.sicIdValue.value = this.getValueOrEmpty(companyDetail.sic);
			}
			if (this.validCompanyValue) {
				this.validCompanyValue.name = 'validCompany';
				this.validCompanyValue.value = true;
			}
			if (this.validAddressValue) this.validAddressValue.value = true;
			this.postalCodeValue.value = companyDetail.postalCode;
			this.townValue.value = companyDetail.town;
			this.foundCompanyNameCreditsafe.textContent = companyDetail.companyName;

			if (
				countryCode === 'IE' ||
				countryCode === 'GB' ||
				countryCode === 'LU'
			) {
				this.address1Value.value =
					`${companyDetail.streetNumber || ''} ${companyDetail.streetName || ''}`.trim();
				this.foundAddressCreditsafe.textContent =
					`${companyDetail.streetNumber || ''} ${companyDetail.streetName || ''}`.trim();
			} else {
				this.address1Value.value =
					`${companyDetail.streetName || ''} ${companyDetail.streetNumber || ''}`.trim();
				this.foundAddressCreditsafe.textContent =
					`${companyDetail.streetName || ''} ${companyDetail.streetNumber || ''}`.trim();
			}
			document.getElementById('foundTownCreditsafe').textContent =
				companyDetail.town;
			document.getElementById('foundPostalCodeCreditsafe').textContent =
				companyDetail.postalCode;
			document.getElementById('foundCountryCreditsafe').textContent =
				companyDetail.country;
		} else {
			this.resetFields(
				[
					this.creditSafeConnectIdValue,
					this.creditCheckedCompanyIdValue,
					this.sicIdValue,
				],
				true,
			);

			this.resetFields([
				this.companyNameValue,
				this.postalCodeValue,
				this.townValue,
				this.address1Value,
				this.chamberOfCommerceIdValue,
				this.companyTaxNumberValue,
			]);

			this.validCompanyValue.name = '';
			this.validCompanyValue.value = false;
			this.validAddressValue.value = false;
		}
	}

	resetFields(fields, resetName = false) {
		fields.forEach(field => {
			if (field) {
				if (field) field.value = '';
				if (field && resetName) field.name = '';
			}
		});
	}

	getValueOrEmpty(str) {
		return str || '';
	}

	setBillingFormElementsVisibility(isManual) {
		this.foundedCompaniesContainerView.toggleAttribute('hidden', isManual);
		const billingFormElements = [
			this.companyNameContainer,
			this.addressValidationContainer,
			this.addressCardContainer,
			this.address1Container,
			this.address2Container,
			this.countrySelector,
			this.postalCodeAndTownContainer,
			this.chamberOfCommerceIdContainer,
		];
		billingFormElements.forEach(element => {
			element?.toggleAttribute('hidden', !isManual);
		});
	}

	creditsafeCompanySearchFormVisibility(event) {
		event.preventDefault();

		this.countrySelector?.toggleAttribute('hidden', true);
		this.creditsafeCompanySearchForm?.toggleAttribute('hidden', false);
		this.billingForm?.toggleAttribute('hidden', true);
	}

	toggleInputLabel() {
		const radioButtons = document.querySelectorAll('input[name="company"]');
		const textCompanyRegistration = document.getElementById(
			'textCompanyRegistration',
		);
		const textCompanyName = document.getElementById('textCompanyName');
		const searchBarCreditsafe = document.getElementById('searchBarCreditsafe');
		const placeholderElement = document.getElementById(
			'searchBarCreditsafePlaceHolder',
		);
		const searchBarCreditsafePlaceHolder = placeholderElement
			? placeholderElement.dataset.placeholder
			: '';

		radioButtons?.forEach(radio => {
			radio.addEventListener('change', () => {
				searchBarCreditsafe.value = '';
				this.foundCompanyContainer.setAttribute('hidden', '');
				document.getElementById('errorMessageElement').textContent = '';
				if (radio.value === 'number' && radio.checked) {
					textCompanyRegistration.classList.remove('d-none');
					textCompanyName.classList.add('d-none');
					searchBarCreditsafe.placeholder = searchBarCreditsafePlaceHolder;
				} else if (radio.value === 'name' && radio.checked) {
					searchBarCreditsafe.placeholder = '';
					textCompanyRegistration.classList.add('d-none');
					textCompanyName.classList.remove('d-none');
				}
			});
		});
	}
}
